import { render, staticRenderFns } from "./TrainingQuotes.vue?vue&type=template&id=d362344c"
import script from "./TrainingQuotes.vue?vue&type=script&lang=js"
export * from "./TrainingQuotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports